import React, { useMemo, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import DupontCrest from "../../../assets/DuPontCrestHome.png";

// All historical du Pont images in public/images/tapestry/
const tapestryFilenames = [
  // Family founders & patriarchs
  "pierre-samuel-dupont-portrait.jpg",
  "pierre-samuel-engraving.jpg",
  "pierre-samuel-portrait-3.jpg",
  "pierre-samuel-bust.jpg",
  "ei-dupont-founder.png",
  "sophie-dalmas-dupont.jpg",
  "dupont-signature.png",
  "nicole-rencourt.jpg",
  "lavoisier-dupont.png",
  // Military & civil service
  "admiral-sf-dupont.jpg",
  "sf-dupont-painting.jpg",
  "sf-dupont-nara.jpg",
  "henry-dupont.png",
  "dupont-coat-of-arms.svg",
  // Later family members
  "eugene-dupont.jpg",
  "alexis-felix-dupont.jpg",
  "alexis-felix-jr-1935.jpg",
  "alice-belin-dupont.jpg",
  "amy-elizabeth-dupont.jpg",
  "william-dupont-jr-1919.jpg",
  "ruth-henry-dupont.jpg",
  "dupont-roosevelt.jpg",
  "grand-nieces-1921.jpg",
  "francis-gurney-dupont.jpg",
  "antoine-bidermann-dupont.jpg",
  "louise-crowninshield.jpg",
  "elizabeth-bradford-dupont.jpg",
  "dorcas-vandyke-dupont.jpg",
  "jacques-biderman.png",
  // Powder mills & Eleutherian Mills
  "eleutherian-mills-watercolor.jpg",
  "powder-mill-stereo.jpg",
  "1810s-powder-mill.jpg",
  "1810s-powder-mills-wide.jpg",
  "machine-shop-eleutherian.jpg",
  "dupont-gunpowders.jpg",
  // Hagley Museum
  "hagley-museum.jpg",
  "brandywine-creek-hagley.jpg",
  "hagley-steps.jpg",
  "hagley-mill-equipment.jpg",
  "hagley-mill-race.jpg",
  "hagley-restored-mill.jpg",
  "hagley-unrestored-mill.jpg",
  "putnam-lathe-hagley.jpg",
  "hagley-first-dupont-home.jpg",
  "hagley-scenic-byway.jpg",
  // Winterthur
  "winterthur-museum.jpg",
  "winterthur-interior.jpg",
  "winterthur-stone-cottage.jpg",
  // Longwood Gardens
  "longwood-conservatory.jpg",
  "longwood-italian-garden.jpg",
  "longwood-fountains.jpg",
  "longwood-fountain-night.jpg",
  "longwood-garden-1.jpg",
  "longwood-garden-2.jpg",
  "longwood-garden-3.jpg",
  // Nemours Mansion
  "nemours-mansion.jpg",
  "nemours-colonnade.jpg",
  "nemours-carillon.jpg",
  "nemours-side-garden.jpg",
  "nemours-long-walk.jpg",
  "nemours-fountain.jpg",
  // DuPont facilities & buildings
  "dupont-experimental-station.jpg",
  "dupont-exp-station-geese.jpg",
  "dupont-exp-station-gate.jpg",
  "dupont-chestnut-run.jpg",
  "dupont-guest-estate.jpg",
  "dupont-building-wilmington.jpg",
  "dupont-orlon-plant.jpg",
  "dupont-washington-works.jpg",
  "dupont-belle-works.png",
  "dupont-belle-plant-marker.jpg",
  // Logos & branding
  "dupont-logo-oval.svg",
  "dupont-logo-modern.svg",
  "dupont-tyvek-logo.svg",
  // Manhattan Project & nuclear
  "hanford-b-reactor-construction.jpg",
  "hanford-b-reactor-exterior.jpg",
  "hanford-b-reactor-control.jpg",
  "hanford-b-reactor-control-station.jpg",
  "hanford-b-reactor-face.jpg",
  "hanford-b-reactor-tubes.jpg",
  "hanford-n-reactor.jpg",
  "hanford-b-area-wwii.jpg",
  "trinity-test-mushroom.jpg",
  "trinity-explosion-color.jpg",
  "trinity-explosion-2.jpg",
  "fat-man-museum.jpg",
  "fat-man-components.png",
  "manhattan-project-emblem.svg",
  "savannah-river-site.jpg",
  // Products & innovation
  "wallace-carothers-lab.jpg",
  "wallace-carothers-portrait.png",
  "wallace-carothers-seated.png",
  "stephanie-kwolek.jpg",
  "nylon-sample-1939.jpg",
  "nylon-stockings-line.jpg",
  "nylon-salvage-wwii.jpg",
  "kevlar-pasgt-vest.jpg",
  "mk6-kevlar-helmet.jpg",
  "tyvek-house.jpg",
  "tyvek-house-full.jpg",
  "teflon-pan.jpg",
  // NASCAR
  "jeff-gordon-24-dupont.jpg",
  "gordon-pitstop-1997.jpg",
  "gordon-sonoma-2005.jpg",
  "gordon-2012-race.jpg",
  // WWII era
  "rosie-the-riveter.jpg",
  // Brandywine Valley & Delaware
  "brandywine-park-bridges.jpg",
  "brandywine-village.jpg",
  "brandywine-1908-painting.jpg",
  "battle-brandywine-marker.jpg",
  "rodney-square-wilmington.jpg",
  "wilmington-library.jpg",
  // Gunpowder heritage
  "gunpowder-kegs-historical.jpg",
  "gunpowder-barrel-citadel.jpg",
  "gunpowder-barrel-curtis-harvey.jpg",
  "gunpowder-barrel-hall-sons.jpg",
  "powder-flask-copper-brass.jpg",
  "battle-new-orleans-1812.jpg",
  "battle-cryslers-farm-1812.jpg",
  "perry-victory-lake-erie-1812.jpg",
  // Kevlar & body armor
  "kevlar-weave-closeup.jpg",
  "aramid-fiber-kevlar.jpg",
  "aramid-fiber-strands.jpg",
  "kevlar-carbon-fiber-canoe.jpg",
  "ballistic-protection-vest.jpg",
  "bulletproof-vest-testing-1923.jpg",
  "soldiers-body-armor-test.jpg",
  "stephanie-kwolek-portrait.png",
  // Philanthropy & estates
  "nemours-childrens-hospital.jpg",
  "dupont-hospital-children.jpg",
  "nemours-reflecting-pool.jpg",
  "nemours-maze-garden.jpg",
  "nemours-mansion-gardens.jpg",
  "nemours-sunken-garden.jpg",
  "longwood-conservatory-exterior.jpg",
  "winterthur-sundial-garden.jpg",
  "winterthur-reflecting-pool.jpg",
  "dupont-gunpowder-ad-color.png",
  "philadelphia-saltpetre-explosion.png",
  "dupont-explosives-emblem.png",
  "dupont-powder-ad-color.jpg",
  "longwood-fountains-color.jpg",
  "nemours-pool-color.jpg",
];

// These images keep their color instead of being greyscaled
const colorHighlightImages = new Set([
  "dupont-gunpowder-ad-color.png",
  "philadelphia-saltpetre-explosion.png",
  "dupont-explosives-emblem.png",
  "dupont-powder-ad-color.jpg",
  "longwood-fountains-color.jpg",
  "nemours-pool-color.jpg",
]);

const LOADING_MESSAGES = [
  "Setting the family table\u2026",
  "Hanging the portraits\u2026",
  "Arranging the archives\u2026",
  "Pressing the linens\u2026",
  "Polishing the silver\u2026",
  "Opening the parlor doors\u2026",
  "Laying out the heirlooms\u2026",
  "Lighting the chandelier\u2026",
  "Dusting the mantelpiece\u2026",
  "Welcoming the family home\u2026",
  "Unfurling the family banner\u2026",
  "Winding the grandfather clock\u2026",
  "Brewing a pot of tea\u2026",
  "Sorting the old photographs\u2026",
  "Stoking the hearth\u2026",
  "Opening the garden gate\u2026",
];

const MESSAGE_INTERVAL = 3000;

// Simple seeded number generator so positions are consistent across renders
function seededRandom(seed) {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

function shuffleArray(arr) {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

function Home() {
  const [imagesReady, setImagesReady] = useState(false);
  const [isRevealing, setIsRevealing] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const [messageFading, setMessageFading] = useState(false);
  const shuffledMessages = useRef(shuffleArray(LOADING_MESSAGES));
  const timerRef = useRef(null);

  // Reveal the page quickly. The tapestry is decorative and now loads lazily
  // behind the content (loading="lazy" below), so we never block the screen on
  // ~160 background images — previously up to an 8-second wait, worst of all on a phone.
  useEffect(() => {
    const t = setTimeout(() => setImagesReady(true), 700);
    return () => clearTimeout(t);
  }, []);

  // Rotate loading messages
  useEffect(() => {
    if (!imagesReady && !isRevealing) {
      timerRef.current = setInterval(() => {
        setMessageFading(true);
        setTimeout(() => {
          setMessageIndex((prev) => (prev + 1) % shuffledMessages.current.length);
          setMessageFading(false);
        }, 150);
      }, MESSAGE_INTERVAL);
    }
    return () => clearInterval(timerRef.current);
  }, [imagesReady, isRevealing]);

  // Reveal animation when images are ready
  useEffect(() => {
    if (imagesReady && !isRevealing) {
      setIsRevealing(true);
      clearInterval(timerRef.current);
    }
  }, [imagesReady, isRevealing]);

  // Compute scattered positions for each image, once
  // Shuffle photos into a new order on every page load.
  // Color photos are spread evenly so they don't clump together.
  const tapestryImages = useMemo(() => {
    // Separate color and greyscale photos, then shuffle both
    const colorFiles = shuffleArray(
      tapestryFilenames.filter((f) => colorHighlightImages.has(f))
    );
    const greyFiles = shuffleArray(
      tapestryFilenames.filter((f) => !colorHighlightImages.has(f))
    );

    // Insert color photos at evenly spaced intervals
    const distributed = [...greyFiles];
    const segmentSize = Math.floor(greyFiles.length / colorFiles.length);
    colorFiles.forEach((img, i) => {
      const insertAt = i * segmentSize + Math.floor(Math.random() * segmentSize);
      distributed.splice(insertAt, 0, img);
    });

    // Position each photo in the grid
    const count = distributed.length;
    const cols = 8;
    const rows = Math.ceil(count / cols);
    const cellWidth = 100 / cols;
    const cellHeight = 100 / rows;

    return distributed.map((filename, i) => {
      const rand = seededRandom(i * 1337 + 42);
      const col = i % cols;
      const row = Math.floor(i / cols);
      const left = col * cellWidth + rand() * cellWidth * 0.8;
      const top = row * cellHeight + rand() * cellHeight * 0.5;
      const isColor = colorHighlightImages.has(filename);
      const isLogo = false; // no standalone logo in tapestry
      const width = isLogo ? 240 : isColor ? 260 + rand() * 80 : 140 + rand() * 120;
      const rotate = isLogo ? -2 : (rand() - 0.5) * 10;
      const opacity = isLogo
        ? 0.85
        : isColor
        ? 0.40 + rand() * 0.10
        : 0.12 + rand() * 0.08;
      const filter = isLogo
        ? "none"
        : isColor
        ? "saturate(130%) brightness(1.1)"
        : "grayscale(100%) sepia(30%)";
      // Color photos get z-index 1 to render ABOVE the cream overlay
      const zIndex = isColor ? 1 : "auto";
      const boxShadow = isColor
        ? "0 4px 20px rgba(0,0,0,0.15)"
        : "none";

      return {
        src: `/images/tapestry/${filename}`,
        top: `${top}%`,
        left: `${left}%`,
        width: `${Math.round(width)}px`,
        rotate: `${rotate.toFixed(1)}deg`,
        opacity,
        filter,
        boxShadow,
        zIndex,
      };
    });
  }, []);

  const quickLinks = [
    {
      title: "Family Tree",
      description: "Explore generations of family history",
      path: "/tree",
    },
    {
      title: "Ask AI",
      description: "Ask questions about family history and the app",
      path: "/ask-ai",
    },
    {
      title: "Bulletin & Blog",
      description: "Family announcements, news and stories",
      path: "/bulletin",
    },
    {
      title: "Marketplace",
      description: "Family heirlooms and memorabilia",
      path: "/marketplace",
    },
    {
      title: "The Scrapbook",
      description: "Photographs, clips and keepsakes",
      path: "/connect?tab=scrapbook",
    },
    {
      title: "Family Connect Hub",
      description: "Find and connect with cousins",
      path: "/connect",
    },
    {
      title: "Correspondence",
      description: "Exchange letters with family members",
      path: "/connect?tab=correspondence",
    },
  ];

  // Opened in a new tab so members don't lose their place on the site.
  const officeForms = [
    {
      title: "Family Update Form",
      description:
        "Send the office a birth, death, marriage, address or other family update.",
      href: "https://www.cognitoforms.com/GenealogyCommittee/FamilyUpdateForm",
    },
    {
      title: "Order a Genealogy Insert",
      href: "https://www.cognitoforms.com/GenealogyCommittee/ORDERFORM2022GenealogyInsert",
    },
  ];

  return (
    <div className="relative flex flex-col w-full min-h-full overflow-hidden">
      {/* Loading overlay — shows while tapestry images preload */}
      {!isRevealing ? (
        <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-dupontCream dark:bg-darkPrimary">
          <img
            src={DupontCrest}
            alt="du Pont family crest"
            className="w-[160px] h-[160px] object-contain mb-[24px]"
            style={{ animation: "crestFloat 3s ease-in-out infinite", willChange: "transform", transform: "translateZ(0)" }}
          />
          <div className="min-h-[40px] max-w-[400px] flex items-center">
            <p
              className="text-[18px] font-body text-dupontGold text-center italic transition-all duration-300"
              style={{
                opacity: messageFading ? 0 : 1,
                transform: messageFading ? "translateY(8px)" : "translateY(0)",
              }}
            >
              {shuffledMessages.current[messageIndex]}
            </p>
          </div>
          <div className="flex gap-x-[8px] mt-[20px]">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="w-[8px] h-[8px] rounded-full bg-dupontGold"
                style={{
                  animation: "pulse 1.4s ease-in-out infinite",
                  animationDelay: `${i * 0.2}s`,
                }}
              />
            ))}
          </div>
        </div>
      ) : (
        // Brief fade-out transition
        <div
          className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-dupontCream dark:bg-darkPrimary pointer-events-none"
          style={{
            animation: "fadeOut 600ms ease-out forwards",
          }}
        />
      )}

      {/* Faded tapestry background — historical du Pont images */}
      <div
        className="absolute inset-0 z-0 pointer-events-none"
        aria-hidden="true"
        style={{ minHeight: "200%" }}
      >
        {tapestryImages.map((img, i) => (
          <img
            key={i}
            src={img.src}
            alt=""
            loading="lazy"
            decoding="async"
            className="absolute object-contain"
            style={{
              top: img.top,
              left: img.left,
              width: img.width,
              transform: `rotate(${img.rotate})`,
              opacity: img.opacity,
              filter: img.filter,
              boxShadow: img.boxShadow || "none",
              zIndex: img.zIndex || "auto",
            }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
        ))}
        {/* Cream overlay to softly blend the images into the background */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(248,245,235,0.3), rgba(253,252,247,0.2), rgba(240,234,214,0.3))",
          }}
        />
      </div>

      {/* Page content — sits above the tapestry */}
      <div className="relative z-10 flex flex-col w-full min-h-full">
        {/* Hero Section */}
        <div className="flex flex-col items-center pt-[48px] pb-[32px]">
          <img
            src={DupontCrest}
            alt="du Pont family crest"
            className="w-[220px] h-[220px] object-contain mb-[20px]"
            style={{ animation: "crestFloat 4s ease-in-out infinite", opacity: 0.9, willChange: "transform", transform: "translateZ(0)" }}
          />
          <h1 className="text-[42px] font-blackletter text-dupontBlue dark:text-darkText text-center leading-tight">
            du Pont Circle
          </h1>
          <div className="w-[80px] h-[1px] bg-dupontGold mt-[12px] mb-[8px]"></div>
          <p className="text-[19px] font-display italic text-dupontBlue/80 dark:text-darkText/80 text-center max-w-[500px] leading-relaxed tracking-wide">
            A private gathering place for family — to explore our shared history,
            connect with one another, and keep the bonds strong across generations.
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col items-center px-[40px] pb-[48px]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px] max-w-[800px] w-full">
            {/* Each tile is a real link (Tab reaches it, Enter opens it) and its
                title an h2, straight under the page's h1; same look as before. */}
            {quickLinks.map((link, index) => (
              <Link
                key={link.path}
                to={link.path}
                className={`flex flex-col p-[24px] bg-white/90 dark:bg-darkCard/90 backdrop-blur-sm rounded-[12px] border card-3d transition-all duration-300 cursor-pointer group no-underline ${
                  index === quickLinks.length - 1 && quickLinks.length % 2 === 1
                    ? "md:col-span-2"
                    : ""
                }`}
              >
                <h2 className="text-[20px] font-display font-semibold text-dupontBlue dark:text-darkText mb-[6px] group-hover:text-dupontGoldDk transition-colors duration-300">
                  {link.title}
                </h2>
                <p className="text-[15px] font-body font-medium leading-relaxed text-[#5a5a5a] dark:text-darkText/80">
                  {link.description}
                </p>
              </Link>
            ))}
          </div>
        </div>

        {/* Family forms — the Genealogy office's own Cognito forms (9/25
            meeting). Kept here, not on the Footprint/Blog page, because the
            office wants family updates separate from the blog. Links only. */}
        <div className="flex flex-col items-center px-[40px] pb-[48px]">
          <div className="max-w-[800px] w-full">
            <h2 className="text-[24px] font-display font-semibold text-dupontBlue dark:text-darkText text-center mb-[16px]">
              Family forms
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px] w-full">
              {officeForms.map((form) => (
                <a
                  key={form.href}
                  href={form.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col p-[24px] bg-white/90 dark:bg-darkCard/90 backdrop-blur-sm rounded-[12px] border card-3d transition-all duration-300 cursor-pointer group no-underline"
                >
                  <h3 className="text-[20px] font-display font-semibold text-dupontBlue dark:text-darkText mb-[6px] group-hover:text-dupontGoldDk transition-colors duration-300">
                    {form.title}
                  </h3>
                  {form.description && (
                    <p className="text-[15px] font-body font-medium leading-relaxed text-[#5a5a5a] dark:text-darkText/80">
                      {form.description}
                    </p>
                  )}
                </a>
              ))}
            </div>
          </div>
        </div>

      </div>


      {/* Inline keyframes for loading animations */}
      <style>{`
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.6; transform: scale(0.95); }
          50% { opacity: 1; transform: scale(1.05); }
        }
        @keyframes crestFloat {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        .card-3d {
          border-color: #d4c26a;
          box-shadow: 0 1px 2px rgba(0,0,0,0.06), 0 4px 8px rgba(0,0,0,0.06), 0 8px 20px rgba(0,0,0,0.04);
        }
        .card-3d:hover {
          border-color: #b5a03e;
          box-shadow: 0 2px 4px rgba(0,0,0,0.08), 0 8px 16px rgba(0,0,0,0.08), 0 16px 32px rgba(0,0,0,0.06);
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
}

export default Home;
